import { GlLink } from '@gitlab/ui';
export default {
    name: 'ResourceParentLink',
    components: {
        GlLink
    },
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    computed: {
        resourceParent () {
            return this.event.resource_parent;
        }
    }
};
